module.exports = __webpack_public_path__ + "static/manju-5f0879a1517aee984deb3963de9d1a74.jpg";